export const AKAMAI_DC = "x-akamai-device-characteristics";
export const AKAMAI_DC_KIND = {
  isMobile: "is_mobile",
  isTablet: "is_tablet",
};
const isTablet = (akamaiDCHeaders: Record<string, string>) =>
  akamaiDCHeaders?.[AKAMAI_DC_KIND.isTablet];
const isMobile = (akamaiDCHeaders: Record<string, string>) =>
  akamaiDCHeaders?.[AKAMAI_DC_KIND.isMobile];

export function akamaiGetDevice(
  headers: Record<string, string | string[]> = {}
) {
  const akamaiDCHeaders = akamaiDCparser(headers[AKAMAI_DC] as string);

  const isTabletHeader = isTablet(akamaiDCHeaders) || headers["tablet-device"];
  const isMobileHeader =
    isMobile(akamaiDCHeaders) ||
    headers["mobile-device"] ||
    (headers["app-version"] ? "true" : undefined);

  let device: "desktop" | "tablet" | "mobile" = "desktop";

  switch ("true") {
    case isTabletHeader:
      device = "tablet";
      break;
    case isMobileHeader:
      device = "mobile";
      break;
    default:
      device = getDeviceFromUserAgent(headers["user-agent"] as string);
      break;
  }
  return device;
}

const TABLET_RE = /(ipad|tablet|(android(?!.*mobile))|kindle|playbook|silk)/i;
const MOBILE_RE =
  /(mobi|iphone|ipod|android.*mobile|windows phone|blackberry)/i;

function getDeviceFromUserAgent(
  userAgent: string | undefined
): "desktop" | "tablet" | "mobile" {
  if (!userAgent) return "desktop";
  if (TABLET_RE.test(userAgent)) return "tablet";
  if (MOBILE_RE.test(userAgent)) return "mobile";
  return "desktop";
}

export const akamaiDCparser = (header: string | undefined) => {
  const separator = ";";
  if (!header) {
    return {};
  }
  try {
    const akamaiDCHeader = Object.fromEntries(
      header
        .split(separator)
        .map((v) => v.split(/=(.*)/).map(decodeURIComponent))
    );
    return akamaiDCHeader;
  } catch (e) {
    return {};
  }
};
